<template>
	<div>
		<div class="modal fade" id="addArticleModal" ref="modalEle" tabindex="-1">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Dodaj artykuł</h5>
						<button type="button" class="close ms-auto" data-bs-dismiss="modal">
							<span>&times;</span>
						</button>
					</div>
					<div class="px-3 pt-3">
						<ul class="nav nav-tabs">
							<li class="nav-item">
								<button class="nav-link" :class="{ active: activeTab === 1 }"
									@click.prevent="activeTab = 1">
									Dane produktu
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="{ active: activeTab === 2 }"
									@click.prevent="activeTab = 2">
									Pozostałe dane
								</button>
							</li>
						</ul>
					</div>

					<div class="modal-body">
						<!-- TAB 1 -->
						<div v-show="activeTab === 1" class="row g-3">
							<div class="col-md-4">
								<label class="form-label">Nr katalogowy</label>
								<input v-model="catalog_number" class="form-control form-control-sm"
									:class="{ 'is-invalid': errors.catalog_number }" placeholder="Np: 00000000" />
							</div>
							<div class="col-md-4">
								<label class="form-label">Model</label>
								<input v-model="model" class="form-control form-control-sm"
									:class="{ 'is-invalid': errors.model }" placeholder="Np: TST-123456789-DEMO" />
							</div>
							<div class="col-md-4">
								<label class="form-label">Jednostka</label>
								<select v-model="article_unit_id" class="form-select form-select-sm"
									:class="{ 'is-invalid': errors.article_unit_id }">
									<option v-for="u in units" :key="u.id" :value="u.id">
										{{ u.name }}
									</option>
								</select>
							</div>
							<div class="col-md-4">
								<label class="form-label">Nazwa / opis</label>
								<input v-model="description" class="form-control form-control-sm"
									:class="{ 'is-invalid': errors.description }"
									placeholder="Np: Pozycja szablon testowy" />
							</div>


							<div class="col-md-4">
								<label class="form-label">Kategoria</label>
								<select v-model="category_id" :class="{ 'is-invalid': errors.category_id }"
									class="form-select form-select-sm">
									<option v-for="c in categories" :key="c.id" :value="c.id">
										{{ c.name }}
									</option>
								</select>
							</div>
							<div class="col-md-4">
								<label class="form-label">Szczegóły</label>
								<input v-model="details" class="form-control form-control-sm"
									placeholder="Np: Stal miękka" />
							</div>

							<div class="col-md-8">
								<label class="form-label">Link</label>
								<input v-model="link" class="form-control form-control-sm"
									placeholder="Np: http://link.pl/artykul?id=123" />
							</div>

							<div class="col-md-4">
								<label class="form-label">Usługa</label>
								<select v-model="is_usluga" class="form-select form-select-sm">
									<option value="0">Nie</option>
									<option value="1">Tak</option>
								</select>
							</div>


						</div>

						<!-- TAB 2 -->
						<div v-show="activeTab === 2" class="row g-3">

							<div class="col-md-6 position-relative">
								<label class="form-label">Producent</label>
								<input
    v-model="producerSearch"
    @input="searchProducers"
    class="form-control form-control-sm"
    autocomplete="off"
/>
								<ul v-if="producerResults.length" class="list-group position-absolute w-100 z-3">
									<li v-for="p in producerResults" :key="p.id"
										class="list-group-item list-group-item-action" @click="selectProducer(p)">{{
											p.name }}</li>
								</ul>
							</div>


							<div class="col-md-6">
								<label class="form-label">Dostawcy</label>
								<input ref="suppliersMulti" />
							</div>

							<div class="row g-3">
								<div class="col-md-3">
									<label class="form-label">Waluta</label>

									<select v-model="currency_id" @change="onCurrencyChange"
										class="form-select form-select-sm"
										:class="{ 'is-invalid': errors.currency_id }">
										<option v-for="c in currencys" :key="c.id" :value="c.id">{{ c.name }}</option>
									</select>
								</div>
								<div class="col-md-3">
									<label class="form-label">VAT</label>
									<input v-model="vat" @input="onVatChange" type="number"
										class="form-control form-control-sm" :class="{ 'is-invalid': errors.vat }" />
								</div>



								<div class="col-md-3">
									<label class="form-label">Cena Netto</label>
									<input v-model="price_netto" @input="onNettoChange" type="number"
										class="form-control form-control-sm"/>
								</div>

								<div class="col-md-3">
									<label class="form-label">Cena Brutto</label>
									<input v-model="price_brutto" @input="onBruttoChange" type="number"
										class="form-control form-control-sm" />
								</div>
							</div>
							<div class="col-md-3">
								<label class="form-label">Cena Netto PLN</label>
								<input v-model="price_netto_zl" type="number" class="form-control form-control-sm"
									disabled />
							</div>

							<div class="col-md-3">
								<label class="form-label">Cena Brutto PLN</label>
								<input v-model="price_brutto_zl" type="number" class="form-control form-control-sm"
									disabled />
							</div>
							<div class="col-md-6">
								<label class="form-label">Lokalizacja</label>
								<input v-model="location" class="form-control form-control-sm" />
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
							@click="resetForm">Zamknij</button>
						<button type="button" class="btn btn-primary" @click="submit">Zapisz artykuł</button>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';
import { MultiSelect } from '@syncfusion/ej2-dropdowns';

export default {
	props: {
		units: { type: Array, default: () => [] },
		producers: { type: Array, default: () => [] },
		currencys: { type: Array, default: () => [] },
		categories: { type: Array, default: () => [] },
		suppliers: Array,
		exchangeRates: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			lastPriceEdited: null,
			modalObj: null,
			activeTab: 1,
			catalog_number: '',
			model: '',
			description: '',
			details: '',
			link: '',
			location: '',
			is_usluga: 0,
			article_unit_id: null,
			producer_id: null,
			category_id: null,
			suppliers_short_names: '',
			vat: 23,
			price_netto_zl: 0,
			price_brutto_zl: 0,
			price_netto: 0,
			price_brutto: 0,
			errors: {},
			producerSearch: '',
			producerResults: [],

			suppliersMultiObj: null,
			suppliers_array: []
		};
	},

	mounted() {
		this.$nextTick(() => {
			const el = this.$refs.modalEle;
			if (el) this.modalObj = new Modal(el);
		});
		this.$nextTick(() => {
			const el = this.$refs.suppliersMulti;

			if (el) {
				this.suppliersMultiObj = new MultiSelect({
					dataSource: this.suppliers, // albo przekaż jako prop
					fields: { text: 'short_name', value: 'short_name' },
					placeholder: 'Wybierz dostawców',
					mode: 'Box',
					allowFiltering: true,
					popupHeight: '200px',
					closePopupOnSelect: false,
					change: (e) => {
						this.suppliers_array = e.value;
					}
				});

				this.suppliersMultiObj.appendTo(el);
			}
		});
	},
	watch: {
		units: {
			immediate: true,
			handler(val) {
				//console.log('units:', val);
			}
		}
	},
	computed: {

		selectedCurrencyName() {

			const currency = this.currencys.find(
				c => c.id == this.currency_id
			);

			return currency ? currency.name : '';
		}

	},
	methods: {
		onCurrencyChange() {
			const rate = this.getRate(this.currency_id);

			this.price_netto_zl = (
				(parseFloat(this.price_netto) || 0) * rate
			).toFixed(2);

			this.price_brutto_zl = (
				(parseFloat(this.price_brutto) || 0) * rate
			).toFixed(2);
		},

		getRate(currencyId) {

			const currency = this.currencys.find(c => c.id == currencyId);

			if (!currency) {
				return 1;
			}

			return parseFloat(
				this.exchangeRates?.rates?.[currency.name.toLowerCase()] ?? 1
			);
		},

		searchProducers() {
			const value = this.producerSearch.trim();
			this.producer_id = null;

			if (value.length < 1) {
				this.producerResults = [];
				return;
			}

			this.producerResults = this.producers.filter(p =>
				p.name.toLowerCase().includes(value.toLowerCase())
			);
			const exactProducer = this.producers.find(
				p => p.name.trim().toLowerCase() === value.toLowerCase()
			);

			if (exactProducer) {
				this.producer_id = exactProducer.id;
			}
		},

		selectProducer(producer) {
			this.producer_id = producer.id;
			this.producerSearch = producer.name;
			this.producerResults = [];
		},

		setDataFromClone(article) {
			this.catalog_number = article.catalog_number || '';
			this.model = article.model || '';
			this.description = article.description || '';
			this.details = article.details || '';
			this.link = article.link || '';
			this.location = article.location || '';
			this.is_usluga = article.is_usluga || 0
			this.article_unit_id = article.unit_id || null;

			this.producer_id = article.producer_id || null;
			this.currency_id = article.currency ?? this.currencys.find(c => c.name.toLowerCase() === 'pln')?.id;

			this.category_id = article.category_id || null;
			if (!article.suppliers) {
				this.suppliers_array = [];
			}
			else if (Array.isArray(article.suppliers)) {
				this.suppliers_array = article.suppliers.map(s => {
					if (typeof s === 'string') return s;
					if (typeof s === 'object') return s.short_name;
					return s;
				});
			}
			else if (typeof article.suppliers === 'string') {
				this.suppliers_array = article.suppliers.split(',');
			}
			else {
				this.suppliers_array = [];
			}

			if (this.suppliersMultiObj) {
				this.suppliersMultiObj.value = this.suppliers_array;
			}

			this.vat = article.vat ?? 23;

			this.price_netto_zl = article.price_netto_zl ?? 0;
			this.price_brutto_zl = article.price_brutto_zl ?? 0;
			this.price_netto = article.price_netto ?? 0;
			this.price_brutto = article.price_brutto ?? 0;
		},
		calcBrutto(netto, vat) {
			netto = parseFloat(netto) || 0
			vat = parseFloat(vat) || 0
			return +(netto * (1 + vat / 100)).toFixed(2)
		},

		calcNetto(brutto, vat) {
			brutto = parseFloat(brutto) || 0
			vat = parseFloat(vat) || 0
			return +(brutto / (1 + vat / 100)).toFixed(2)
		},

		onNettoZlChange() {

			const rate = this.getRate(this.currency_id);

			this.price_brutto_zl = this.calcBrutto(this.price_netto_zl, this.vat);

			this.price_netto = (
				(parseFloat(this.price_netto_zl) || 0) / rate
			).toFixed(2);

			this.price_brutto = this.calcBrutto(this.price_netto, this.vat);
		},

		onBruttoZlChange() {

			this.price_netto_zl = this.calcNetto(this.price_brutto_zl, this.vat);

			this.onNettoZlChange();
		},

		onNettoChange() {
			this.lastPriceEdited = 'netto';

			const netto = parseFloat(this.price_netto) || 0;
			const vat = parseFloat(this.vat) || 0;

			// Netto -> Brutto
			this.price_brutto = this.calcBrutto(netto, vat);

			// Przeliczenie PLN
			const rate = this.getRate(this.currency_id);

			this.price_netto_zl = (
				netto * rate
			).toFixed(2);

			this.price_brutto_zl = (
				parseFloat(this.price_brutto) * rate
			).toFixed(2);
		},

		onBruttoChange() {
			this.lastPriceEdited = 'brutto';

			const brutto = parseFloat(this.price_brutto) || 0;
			const vat = parseFloat(this.vat) || 0;

			// Brutto -> Netto
			this.price_netto = this.calcNetto(brutto, vat);

			// Przeliczenie PLN
			const rate = this.getRate(this.currency_id);

			this.price_netto_zl = (
				parseFloat(this.price_netto) * rate
			).toFixed(2);

			this.price_brutto_zl = (
				brutto * rate
			).toFixed(2);
		},

		onVatChange() {
			const vat = parseFloat(this.vat) || 0;

			if (this.lastPriceEdited === 'brutto') {

				// Brutto jest wartością wpisaną przez użytkownika
				this.price_netto = this.calcNetto(
					this.price_brutto,
					vat
				);

			} else {

				// Netto jest wartością wpisaną przez użytkownika
				this.price_brutto = this.calcBrutto(
					this.price_netto,
					vat
				);
			}

			const rate = this.getRate(this.currency_id);

			this.price_netto_zl = (
				(parseFloat(this.price_netto) || 0) * rate
			).toFixed(2);

			this.price_brutto_zl = (
				(parseFloat(this.price_brutto) || 0) * rate
			).toFixed(2);
		},
validate() {
    this.errors = {};

    // =========================
    // TAB 1 - Dane produktu
    // =========================

    if (!this.catalog_number || !this.catalog_number.trim()) {
        this.errors.catalog_number = true;
    }

    if (!this.model || !this.model.trim()) {
        this.errors.model = true;
    }

    if (!this.description || !this.description.trim()) {
        this.errors.description = true;
    }

    if (!this.article_unit_id) {
        this.errors.article_unit_id = true;
    }

    if (!this.category_id) {
        this.errors.category_id = true;
    }

    // =========================
    // TAB 2 - Pozostałe dane
    // =========================

    // Producent:
    // musi być wybrany istniejący producent
    // LUB wpisana nazwa ręczni
	/*
    const producerName = (this.producerSearch || '').trim();

    if (!this.producer_id && !producerName) {
        this.errors.producerSearch = true;
    }
*/
    // Cena netto:
    // nie może być pusta, 0 ani ujemna
 /*   const priceNetto = parseFloat(this.price_netto);

    if (
        this.price_netto === null ||
        this.price_netto === '' ||
        isNaN(priceNetto) ||
        priceNetto <= 0
    ) {
        this.errors.price_netto = true;
    }
*/
    return Object.keys(this.errors).length === 0;
},

getFirstErrorTab() {
    const tab1Fields = [
        'catalog_number',
        'model',
        'description',
        'article_unit_id',
        'category_id'
    ];

    const tab2Fields = [
        'producerSearch',
        'price_netto'
    ];

    if (tab1Fields.some(field => this.errors[field])) {
        return 1;
    }

    if (tab2Fields.some(field => this.errors[field])) {
        return 2;
    }

    return 1;
},

		async submit() {
			if (!this.validate()) {
				this.activeTab = this.getFirstErrorTab();
				return;
			}

			const payload = {
				catalog_number: this.catalog_number,
				model: this.model,
				description: this.description,
				details: this.details,
				link: this.link,
				location: this.location,
				is_usluga: this.is_usluga,
				unit_id: this.article_unit_id,
				producer_id: this.producer_id,
				producer_name: this.producerSearch,
				category_id: this.category_id,
				suppliers: this.suppliers_array.join(','),
				vat: this.vat,
				currency: this.currency_id,
				price_netto_zl: this.price_netto_zl,
				price_brutto_zl: this.price_brutto_zl,
				price_netto: this.price_netto,
				price_brutto: this.price_brutto,
			};

			this.$emit('save-article', payload);
		},

		show() {
			this.activeTab = 1;

			if (!this.currency_id) {

				const pln = this.currencys.find(c => c.name.toLowerCase() === 'pln');

				if (pln) {
					this.currency_id = pln.id;
				}
			}

			if (this.modalObj) this.modalObj.show();
		},
		hide() {
			if (this.modalObj) this.modalObj.hide();
		},
		resetForm() {
			this.activeTab = 1;
			this.errors = {};
			this.catalog_number = '';
			this.model = '';
			this.description = '';
			this.details = '';
			this.link = '';
			this.location = '';
			this.is_usluga = 0;
			this.article_unit_id = null;
			this.producer_id = null;
			this.currency_id = this.currencys.find(c => c.name.toLowerCase() === 'pln')?.id ?? null;
			this.producer_name = '';
			this.producerSearch = '';
			this.producerResults = [];
			this.category_id = null;
			this.suppliers_array = [];
			if (this.suppliersMultiObj) {
				this.suppliersMultiObj.value = [];
			}
			this.vat = 23;
			this.price_netto_zl = 0;
			this.price_brutto_zl = 0;
			this.price_netto = 0;
			this.price_brutto = 0;
		}
	}
};
</script>
<style>
.position-absolute {
	background: white;
	max-height: 200px;
	overflow-y: auto;
	border: 1px solid #ddd;
}
</style>